<script setup lang="ts">
import { watch, toRefs, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { utc2local } from "@/utils";
import { useLogStore } from "@/stores/log";

const props = defineProps<{
  type: string;
  searchId: string;
}>();

const logStore = useLogStore();
const { logData, searching, hasMore, debug } = storeToRefs(logStore);
const { type, searchId } = toRefs(props);
const toggleDebug = async () => {
  logStore.toggleDebug();
  await more();
};
const more = async () => {
  await logStore.anotherPage(type.value, searchId.value);
};

onMounted(async () => {
  console.log("loglist mounted");
  logStore.reset();
  await more();
});

watch([type, searchId], async () => {
  console.log(`loglist watch triggered on ${type.value} ${searchId.value}`);
  if (type.value && searchId.value) {
    logStore.reset();
    await more();
  }
});
</script>

<template>
  <h2>Log</h2>
  <pn-table bordered="true">
    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th></th>
          <th>Action</th>
          <th>Message</th>
          <th>Cart</th>
          <th>Order</th>
          <th v-if="type === 'device'">User</th>
          <th v-if="type === 'user'">Device</th>
          <th>Image</th>
          <th>Promotion</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!logData.length">
          <td colspan="9">Empty</td>
        </tr>
        <tr
          v-for="log in logData"
          :key="log.logDate"
          :class="[log.action, log.level]"
        >
          <td>{{ utc2local(log.logDate) }}</td>
          <td>{{ log.level }}</td>
          <td>{{ log.action }}</td>
          <td>{{ log.message }}</td>
          <td>{{ log.cartId ? log.cartId.substring(0, 8) + "..." : "-" }}</td>
          <td>
            <a :href="'/order/' + log.orderId">{{ log.orderId }}</a>
          </td>
          <td v-if="type === 'device'">
            <a :href="'/user/' + log.userId">{{ log.userId }}</a>
          </td>
          <td v-if="type === 'user'">
            <a :href="'/device/' + log.deviceId">{{
              log.deviceId ? log.deviceId.substring(0, 8) + "..." : "-"
            }}</a>
          </td>
          <td>
            {{ log.imageCode }}
            <a v-show="log.imageUrl" :href="log.imageUrl">link</a>
          </td>
          <td>{{ log.promotionCode }}</td>
        </tr>
      </tbody>
    </table>
  </pn-table>
  <pn-spinner size="2" v-show="searching" />
  <p v-show="!hasMore">
    <pn-toast closable="false" text="Entire log loaded"></pn-toast>
  </p>
  <p v-show="hasMore">
    <pn-button v-on:click="more" small="true" appearance="light">
      Load more log entries
    </pn-button>
  </p>
  <pn-button
    v-show="!debug"
    small="true"
    v-on:click="toggleDebug"
    appearance="light"
  >
    Show Debug Log
  </pn-button>
  <pn-button
    v-show="debug"
    small="true"
    v-on:click="toggleDebug"
    appearance="light"
  >
    Hide Debug Log
  </pn-button>
</template>

<style lang="scss" scoped>
.error {
  background: #fee;
}

.note.info {
  background: #efe;
}

.info {
  background: #eef;
}
</style>
